/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { CreateFsScanMissionPolicyCardModule } from 'app/feature/settings/file-storage-service/antivirus/antivirus-policy/filesystem-scan-mission/create-fs-scan-mission-policy-card/create-fs-scan-mission-policy-card.module';

import { CreateFileSystemModule } from '../create-file-system/create-file-system.module';
import { FsSmartGuiInfoComponent } from './fs-smartgui-info.component';

@NgModule({
    declarations: [FsSmartGuiInfoComponent],
    exports: [FsSmartGuiInfoComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        FormsModule,
        CreateFileSystemModule,
        CreateFsScanMissionPolicyCardModule,
    ],
})
export class FsSmartGuiInfoModule { }
